import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getUniteMobiles(): AxiosPromise<AlrContainer<AloBaseArray<AloDbUniteMobile>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/unitemobile', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbUniteMobile>>(JSON.parse(data),AloDbUniteMobile.createAloDbUniteMobileArray)
      }]
    })
  },
  getUniteMobile(id:number):AxiosPromise<AlrContainer<AloDbUniteMobile>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/unitemobile/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbUniteMobile>(JSON.parse(data),AloDbUniteMobile.createAloDbUniteMobileWithDetail)
      }]
    })
  },
  saveUniteMobile(uniteMobile:AloDbUniteMobile):AxiosPromise<AlrContainer<AloDbUniteMobile>> {
    if(uniteMobile.UMB_ID && uniteMobile.UMB_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/unitemobile/${uniteMobile.UMB_ID}`, 
        method: 'PUT',
        data: uniteMobile,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUniteMobile>(JSON.parse(data),AloDbUniteMobile.createAloDbUniteMobileWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/unitemobile`, 
        method: 'POST',
        data: uniteMobile,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUniteMobile>(JSON.parse(data),AloDbUniteMobile.createAloDbUniteMobileWithDetail)
        }]
      })    
    }
    
  }
  
}